






































































































































































import {
  computed, defineComponent, ref, useContext, useRouter, watch,
} from '@nuxtjs/composition-api';
import type { Ref, PropType } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { ProductAvailable } from '~/modules/catalog/product/helpers/stockHelpers';
import ImageWrapper from '~/components/image/ImageWrapper.vue';
import ProductLabels from '~/components/storyblok/ProductLabels.vue';
// import AddToWishlistHeart from '~/modules/catalog/product/components/AddToWishlistHeart.vue';
import { getFullCategoryPath } from '~/plugins/GoogleAnalitycs4/helpers';
import {
  StockItem, useImage, useIntersectionObserver, useUiNotification,
  useUser,
} from '~/composables';
import type { Maybe, CategoryInterface } from '~/modules/GraphQL/types';
import SfImage from './SfImage.vue';
import SfButton from './SfButton/SfButton.vue';
import InfoWithIcon from '../InfoWithIcon.vue';

type CardStyleType = 'normal' | 'compact';

export default defineComponent({
  name: 'SfProductCard',
  components: {
    // AddToWishlistHeart,
    ImageWrapper,
    SfImage,
    SfButton,
    ProductLabels,
    InfoWithIcon,
  },
  props: {
    image: {
      type: [Array, Object, String] as PropType<string | Record<string, unknown>>,
      default: '',
    },
    title: {
      type: String as PropType<string>,
      default: '',
    },
    link: {
      type: [String, Object] as PropType<string | Record<string, unknown>>,
      default: null,
    },
    isInWishlist: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isAddedToCart: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    addToCartDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isPriceHidden: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    available: {
      type: Object as PropType<ProductAvailable>,
      default: () => ({}),
    },
    isNew: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    finalPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    finalNettoPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    omnibusPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    finalPriceRaw: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    regularPrice: {
      type: [String] as PropType<string>,
      default: null,
    },
    specialPrice: {
      type: [String] as PropType<string>,
      default: null,
    },
    isBestseller: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isRecommended: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    manufacturer: {
      type: String as PropType<string>,
      default: '',
    },
    variants: {
      type: String as PropType<string>,
      default: '',
    },
    isProductConfigurable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    parentSku: {
      type: String as PropType<string>,
      default: '',
    },
    sku: {
      type: String as PropType<string>,
      default: '',
    },
    parentId: {
      type: Number as PropType<number>,
      default: null,
    },
    id: {
      type: Number as PropType<number>,
      default: null,
    },
    list: {
      type: String as PropType<string>,
      default: '',
    },
    position: {
      type: Number as PropType<number>,
      default: null,
    },
    mainCategory: {
      type: Number as PropType<number>,
      default: null,
    },
    categories: {
      type: Array as PropType<Maybe<Array<Maybe<CategoryInterface>>>>,
      default: () => [],
    },
    disableHoverEffect: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    qtyConfig: {
      type: Object as PropType<StockItem>,
      default: () => {},
    },
    imageLoading: {
      type: String as PropType<string>,
      default: 'lazy',
    },
    cardStyle: {
      type: String as PropType<CardStyleType>,
      default: '',
    },
    buttonText: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { app } = useContext();
    const { imageSizes } = useImage();
    const router = useRouter();
    const { isAuthenticated, isB2bUser } = useUser();
    const ariaLabel = computed(() => (props.isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'));
    const isCompact = computed(() => props.cardStyle === 'compact');

    // Wishlist
    const isWishlistHovered = ref(false);
    const wishlistIconResolver = computed(() => (!props.isInWishlist ? (isWishlistHovered.value ? 'heart-white' : 'heart-outline') : 'heart-white'));
    const setWishlistHovered = (value: boolean) => {
      isWishlistHovered.value = value;
    };
    const toggleIsInWishlist = () => {
      emit('click:wishlist', !props.isInWishlist);
    };

    // Add to cart
    const isAddingToCart = ref(false);
    const onAddToCart = () => {
      isAddingToCart.value = true;
      setTimeout(() => {
        isAddingToCart.value = false;
      }, 1000);
      emit('click:add-to-cart');
    };

    // Notifications
    const { clear: clearNotifications } = useUiNotification();
    const onChoseVariants = () => {
      clearNotifications();
      router.push(props.link as string);
    };

    // Google Tag Manager
    const productForDL: any = {
      sku: props.sku,
      parentSku: props.parentSku,
      id: props.id,
      parentId: props.parentId,
      position: props.position,
      brand: props.manufacturer,
      name: props.title,
      list: props.list,
      final_price: props.finalPriceRaw,
      final_price_tax: 0, // tax TODO
    };
    if (props.mainCategory) {
      const fullPath = getFullCategoryPath(props.mainCategory, props.categories);

      if (fullPath) {
        productForDL.full_category_path = fullPath;
      }
    }
    const onProductClick = () => {
      app.$googleTagManager.click({
        item: productForDL,
      });
      router.push(props.link as string);
    };

    const root: Ref = ref(null);
    const { isVisible: isProductHasBeenSeen } = useIntersectionObserver(root);
    watch(
      () => isProductHasBeenSeen.value,
      () => {
        if (isProductHasBeenSeen.value) {
          app.$googleTagManager.impressions({
            impressions: [productForDL],
          });
        }
      },
    );

    return {
      root,
      onProductClick,
      addBasePath,
      isAddingToCart,
      isWishlistHovered,
      ariaLabel,
      wishlistIconResolver,
      setWishlistHovered,
      toggleIsInWishlist,
      onAddToCart,
      onChoseVariants,
      imageSizes,
      isCompact,
      isAuthenticated,
      isB2bUser,
    };
  },
});
